const TRADE_DETAILS_COMPANY_NAMES: Record<string, string> = {
  AAPL: 'Apple Inc.',
  MSFT: 'Microsoft Corp.',
  GOOGL: 'Alphabet Inc.',
  GOOG: 'Alphabet Inc.',
  AMZN: 'Amazon.com, Inc.',
  NVDA: 'NVIDIA Corporation',
  TSLA: 'Tesla, Inc.',
  PLTR: 'Palantir Technologies Inc.',
  META: 'Meta Platforms, Inc.',
  NFLX: 'Netflix, Inc.',
  AMD: 'Advanced Micro Devices, Inc.',
  IBM: 'IBM',
  JPM: 'JPMorgan Chase & Co.',
  BAC: 'Bank of America Corp.',
  SPY: 'SPDR S&P 500 ETF Trust',
  QQQ: 'Invesco QQQ Trust',
  DIA: 'SPDR Dow Jones Industrial Average ETF',
};

/** Returns a known company name for a normalized equity/futures symbol. */
export function getTradeDetailsCompanyName(rawSymbol: string): string | undefined {
  const withoutExchange = rawSymbol.includes(':') ? (rawSymbol.split(':').pop() || rawSymbol) : rawSymbol;
  const upper = withoutExchange.toUpperCase().trim();
  const contract = /^([A-Z]+)([FGHJKMNQUVXZ])(\d{1,2}|\d{4})$/.exec(upper);
  const root = contract ? contract[1] : upper.replace(/\d+!?$/g, '').replace(/!$/g, '');
  return TRADE_DETAILS_COMPANY_NAMES[root];
}

/** Trade metadata wins over a resolved lookup, which wins over the static map. */
export function resolveTradeDetailsCompanyName(
  tradeCompany?: string | null,
  resolvedCompany?: string | null,
  mappedCompany?: string | null,
): string | undefined {
  return tradeCompany || resolvedCompany || mappedCompany || undefined;
}
